import React, { useState, useEffect } from "react";
import { ReactComponent as EyeClose } from "../../../assets/eye-close.svg";
import { ReactComponent as EyeOpen } from "../../../assets/eye-open.svg";
import ValidationCheckBox from "./ValidationCheckBox";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrowright.svg";
import Logo from "../Logo";
import {
  useRegisterMutation,
  useLoginMutation,
} from "../../../store/auth/usersApiSlice";
import { setUserInfo, setToken } from "../../../store/auth/authSlice";
import { useDispatch } from "react-redux";
import { ReactComponent as NamePassword } from "../../../assets/images/signUp/nam-password.svg";
import { SideSVG } from "../../common";
import { ReactComponent as Spinner } from "../../../assets/icons/spinner.svg";
import ReactGA from "react-ga4";
import PhoneNumberInput from "../../common/PhoneNumberInput";
import { isPossiblePhoneNumber, isValidPhoneNumber } from "react-phone-number-input";

const Password = ({ onNext, email, isArticle, slug }) => {
  const [name, setName] = useState("");
  const [designation, setDesignation] = useState("");
  const [employer_company_name, setEmployerCompanyName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [inviteCode, setInviteCode] = useState(localStorage.getItem('invite_code'));
  const [hasUppercase, setHasUppercase] = useState(false);
  const [hasLowercase, setHasLowercase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialCharacter, setHasSpecialCharacter] = useState(false);
  const [isMinLength, setIsMinLength] = useState(false);
  const [isButtonValid, setIsButtonValid] = useState(false);
  const [error, setError] = useState("");
  const [phone, setPhone] = useState(null);
  const [showVerified, setShowVerified] = useState(false);

  const dispatch = useDispatch();

  const [register, { isLoading }] = useRegisterMutation();
  const [login] = useLoginMutation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    ReactGA.event({
      category: 'Create New Account',
      action: `Adding Company Profile; ${email?.replace(/@/g, '=')}`,
      label: 'User Submitted data for Created his Profile Profile Note Created Yet.',
    });
    const lastVisited = localStorage.getItem('lastVisited');
    const userToken = sessionStorage.getItem("temp_token");
    const splittedData = lastVisited ? lastVisited?.split('/') : [];
   
    try {
      setError("");
      const res = await register({
        token: userToken,
        name,
        email,
        password,
        designation,
        employer_company_name,
        mobile_number: phone,
        ...(inviteCode && { invite_code: inviteCode }),
        ...(splittedData?.[1] === "search" && { referance: splittedData?.[2] })
      }).unwrap();

      dispatch(setUserInfo({ ...res }));

      const resLogin = await login({
        email,
        password,
        ...(isArticle && { return_magic_token: true }),
        ...(inviteCode && { invite_code: inviteCode })
      }).unwrap();
      let token = resLogin?.token || resLogin?.access
      dispatch(setToken(token));
      if (token) {
        ReactGA.event({
          category: 'Create New Account',
          action: 'Creating Profile',
          label: 'User Created his Profile by setting password',
        });
        if (isArticle) {
          const baseUrl = `${process.env.REACT_APP_K_HUB_URL}/magic/${resLogin.magic_token}`;
          // Only append slug if it's available
          const url = slug ? `${baseUrl}?slug=${slug}` : baseUrl;
          window.open(url, "_blank");
        }
        onNext(true);
      }
    } catch (error) {
      setError(
        error?.data
          ? Object.values(error?.data)[0]
          : "An error occurred. Please try again later."
      );
    }
  };

  const handlePasswordChange = (event) => {
    const value = event.target.value;
    setPassword(value);
    setHasUppercase(/[A-Z]/.test(value));
    setHasLowercase(/[a-z]/.test(value));
    setHasNumber(/[0-9]/.test(value));
    setHasSpecialCharacter(/[!@#$%^&*]/.test(value));
    setIsMinLength(value.length >= 8);
  };

  function validate() {
    setIsButtonValid(
      hasSpecialCharacter &&
      hasLowercase &&
      hasNumber &&
      hasUppercase &&
      isMinLength &&
      phone &&
      isValidPhoneNumber(phone?.toString() ?? "")
      // &&
      // showVerified
    );
  }

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleDesignation = (e) => {
    setDesignation(e.target.value);
  };

  const handleEmployerCompanyName = (e) => {
    setEmployerCompanyName(e.target.value);
  };

  useEffect(() => {
    validate();
  }, [validate]);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <section className="relative px-4 py-20 sm:px-0 sm:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo classes="max-w-md lg:py-5 mx-auto absolute top-[-3.75rem] left-1/2 transform -translate-x-1/2 sm:left-[7rem] sm:top-5 sm:z-10" />
          <div className="flex flex-wrap -mx-4 xl:items-center">
            <div className="flex-flex1 flex items-center justify-center w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-lg w-full lg:py-20 mx-auto ">
                <h3 className="font-heading text-f24 sm:text-h3 text-primary font-bold mb-4 text-center">
                  Create your profile
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className="mb-6">
                    <label
                      className="block mb-1.5 text-sm text-secondarytwo font-semibold text-left"
                      htmlFor="name"
                    >
                      Enter Full Name
                    </label>
                    <input
                      className="w-full py-3 px-4 text-sm text-primary placeholder-gray-400 border-b-2 border-primary focus:border-primary focus:outline-none focus:bg-white"
                      type="text"
                      id="name"
                      required
                      onChange={handleNameChange}
                    />

                    <label
                      className="block mb-1.5 text-secondarytwo text-left font-semibold mt-8"
                      htmlFor="name"
                    >
                      Designation
                    </label>
                    <input
                      className="w-full py-3 px-4 text-sm text-primary placeholder-gray-400 border-b-2 border-primary focus:border-primary focus:outline-none focus:bg-white"
                      type="text"
                      required
                      id="designation"
                      onChange={handleDesignation}
                    />

                    <label
                      className="block mb-1.5 text-secondarytwo text-left font-semibold mt-8"
                      htmlFor="name"
                    >
                      Company Name
                    </label>
                    <input
                      className="w-full py-3 px-4 text-sm text-primary placeholder-gray-400 border-b-2 border-primary focus:border-primary focus:outline-none focus:bg-white"
                      type="text"
                      required
                      id="company_name"
                      onChange={handleEmployerCompanyName}
                    />
                    <label
                      className="block mb-1.5 text-secondarytwo text-left font-semibold mt-8"
                      htmlFor="name"
                    >
                      Phone Number
                    </label>
                    <PhoneNumberInput phone={phone}
                      setPhone={setPhone}
                      showVerified={showVerified}
                      setShowVerified={setShowVerified} verifyPhoneNumber={false} />
                    <input
                      className="w-full py-3 px-4 text-sm  text-gray-900 placeholder-gray-400 border border-gray-200 focus:border-purple-500 focus:outline-purple rounded-lg"
                      type="email"
                      readOnly
                      hidden
                      value={email}
                    />
                    <label
                      className="block mb-1.5 text-secondarytwo text-left font-semibold mt-8"
                      htmlFor=""
                    >
                      Password
                    </label>
                    <div className="relative">
                      <input
                        className="w-full py-3 px-4 text-sm text-primary placeholder-gray-400 border-b-2 border-primary focus:border-primary focus:outline-none focus:bg-white"
                        type={showPassword ? "text" : "password"}
                        required
                        onChange={handlePasswordChange}
                      />
                      <button
                        type="button"
                        onClick={toggleShowPassword}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center"
                      >
                        {showPassword ? <EyeOpen /> : <EyeClose />}
                      </button>
                    </div>
                    {error && (
                      <div className="text-red-500 mt-2 text-left">{error}</div>
                    )}
                  </div>
                  <div id="password-requirements" className="mt-2 mb-6">
                    <ul className="list-disc list-inside">
                      <ValidationCheckBox
                        passed={isMinLength}
                        message="Minimum 8 characters"
                      />
                      <ValidationCheckBox
                        passed={hasUppercase}
                        message="One upper case character"
                      />
                      <ValidationCheckBox
                        passed={hasLowercase}
                        message="One lower case character"
                      />
                      <ValidationCheckBox
                        passed={hasNumber}
                        message="One number character"
                      />
                      <ValidationCheckBox
                        passed={hasSpecialCharacter}
                        message="One Special character(e.g. @, $, #)"
                      />
                    </ul>
                  </div>
                  <button
                    className={`relative group w-full mb-6 py-3 px-5 text-center text-sm font-semibold text-white rounded-md  inline-flex items-center justify-center mr-2 gap-4 ${isButtonValid ? "bg-primary cursor-pointer" : "bg-disable cursor-not-allowed"}`}
                    type="submit"
                    disabled={!isButtonValid}
                  >
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <span className="relative">Next</span>
                    )}
                    <ArrowRight />
                  </button>
                </form>
              </div>
            </div>
            <SideSVG SVG={NamePassword} positions="bottom-0  left-[-20%]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Password;
